<template>
  <model-table
    ref="modelTable"
    title="Modifiers"
    :collection="modifierSet.modifiers"
    submodel
    orderable
    :columns="[
      { field: 'id' },
      { field: 'name' },
      { field: 'price', component: 'money' },
      { field: 'cost', component: 'money' },
      { field: 'availableOnline', align: 'center', component: 'checkbox' },
      { field: 'salesDisabled', component: 'checkmark-or-negative', label: 'Disable Sales' },
      ...(currentSite.activeInventoryStrategy && modifierSet.isRemote ? [
        { name: 'hasRecipe', field: 'trackStock', component: 'checkmark-or-negative', label: 'Track Stock' }
      ] : []),
      { name: 'library', component: 'library-link', hide: currentCircuit.isLibrary, align: 'right' },
      { name: 'actions', align: 'right' }
    ]"
    emit-only-add
    @add="model => $refs.selectModifiersDialog.show(model)"
  >
    <modifier-form
      ref="modifierForm"
      disable-modifier-sets
    />
  </model-table>
  <select-modifiers-dialog
    ref="selectModifiersDialog"
    :modifier-set="modifierSet"
    @create-modifier="model => $refs.modifierForm.$refs.form.show(model)"
  />
</template>

<script>
import ModifierSet from 'src/models/modifier-set/ModifierSet'
import ModelTable from 'src/modules/admin/components/ModelTable'
import ModifierForm from 'src/modules/admin/modifier/ModifierForm'
import SelectModifiersDialog from 'src/modules/admin/modifier-set/SelectModifiersDialog'

export default {
  name: 'ModifierSetModifierTable',
  components: {
    ModelTable,
    ModifierForm,
    SelectModifiersDialog
  },
  configuration: ['currentCircuit', 'currentSite', 'modifiers'],
  props: {
    modifierSet: {
      type: ModifierSet,
      required: true
    }
  }
}
</script>
